import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useCustomerDetail(id) {
  return useSWR(
    !id
      ? null
      : {
          path: `/api/v1/customers/${id}`,
          method: "GET",
          //   params
        },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useCustomerDetail;
